export default {
  schedules: {
    type: Array,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/active-agenda/components/rollback/resources/props.js